/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Confirmdelete1Inputs */

const id_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda yakin ingin menghapus ulasan ini?`)
};

const ms_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adakah anda pasti mahu memadam ulasan ini?`)
};

const da_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er du sikker på at du vil slette denne anmeldelse?`)
};

const de_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind Sie sicher, dass Sie diese Bewertung löschen möchten?`)
};

const en_us2_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this review?`)
};

const es_es2_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar esta reseña?`)
};

const es_mx2_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Estás seguro de que quieres eliminar esta reseña?`)
};

const fil_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sigurado ka bang gusto mong tanggalin ang review na ito?`)
};

const fr_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Êtes-vous sûr de vouloir supprimer cet avis ?`)
};

const it_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare questa recensione?`)
};

const hu_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biztosan törölni szeretnéd ezt az értékelést?`)
};

const nl_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weet je zeker dat je deze review wilt verwijderen?`)
};

const no_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er du sikker på at du vil slette denne omtalen?`)
};

const pl_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy na pewno chcesz usunąć tę recenzję?`)
};

const pt_br2_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this review?`)
};

const pt_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tem a certeza de que deseja eliminar esta avaliação?`)
};

const ro_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ești sigur că dorești să ștergi această recenzie?`)
};

const fi_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oletko varma, että haluat poistaa tämän arvostelun?`)
};

const sv_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Är du säker på att du vill ta bort denna recension?`)
};

const vi_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có chắc chắn muốn xóa đánh giá này không?`)
};

const tr_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu yorumu silmek istediğinizden emin misiniz?`)
};

const cs_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opravdu chcete smazat tuto recenzi?`)
};

const bg_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сигурни ли сте, че искате да изтриете това ревю?`)
};

const ru_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить этот обзор?`)
};

const uk_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви впевнені, що хочете видалити цей відгук?`)
};

const ar_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل أنت متأكد أنك تريد حذف هذه المراجعة؟`)
};

const hi_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप वाकई हटाना चाहते हैं?`)
};

const th_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณแน่ใจหรือไม่ว่าต้องการลบรีวิวนี้?`)
};

const ja_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このレビューを削除してもよろしいですか？`)
};

const zh_cn2_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this review?`)
};

const zh_hant1_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this review?`)
};

const ko_forms_review_confirmdelete1 = /** @type {(inputs: Forms_Review_Confirmdelete1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this review?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this review?" |
*
* @param {Forms_Review_Confirmdelete1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_confirmdelete1 = /** @type {((inputs?: Forms_Review_Confirmdelete1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Confirmdelete1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_confirmdelete1(inputs)
	if (locale === "ms") return ms_forms_review_confirmdelete1(inputs)
	if (locale === "da") return da_forms_review_confirmdelete1(inputs)
	if (locale === "de") return de_forms_review_confirmdelete1(inputs)
	if (locale === "en-US") return en_us2_forms_review_confirmdelete1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_confirmdelete1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_confirmdelete1(inputs)
	if (locale === "fil") return fil_forms_review_confirmdelete1(inputs)
	if (locale === "fr") return fr_forms_review_confirmdelete1(inputs)
	if (locale === "it") return it_forms_review_confirmdelete1(inputs)
	if (locale === "hu") return hu_forms_review_confirmdelete1(inputs)
	if (locale === "nl") return nl_forms_review_confirmdelete1(inputs)
	if (locale === "no") return no_forms_review_confirmdelete1(inputs)
	if (locale === "pl") return pl_forms_review_confirmdelete1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_confirmdelete1(inputs)
	if (locale === "pt") return pt_forms_review_confirmdelete1(inputs)
	if (locale === "ro") return ro_forms_review_confirmdelete1(inputs)
	if (locale === "fi") return fi_forms_review_confirmdelete1(inputs)
	if (locale === "sv") return sv_forms_review_confirmdelete1(inputs)
	if (locale === "vi") return vi_forms_review_confirmdelete1(inputs)
	if (locale === "tr") return tr_forms_review_confirmdelete1(inputs)
	if (locale === "cs") return cs_forms_review_confirmdelete1(inputs)
	if (locale === "bg") return bg_forms_review_confirmdelete1(inputs)
	if (locale === "ru") return ru_forms_review_confirmdelete1(inputs)
	if (locale === "uk") return uk_forms_review_confirmdelete1(inputs)
	if (locale === "ar") return ar_forms_review_confirmdelete1(inputs)
	if (locale === "hi") return hi_forms_review_confirmdelete1(inputs)
	if (locale === "th") return th_forms_review_confirmdelete1(inputs)
	if (locale === "ja") return ja_forms_review_confirmdelete1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_confirmdelete1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_confirmdelete1(inputs)
	return ko_forms_review_confirmdelete1(inputs)
});
export { forms_review_confirmdelete1 as "forms.review.confirmDelete" }